import './config/wdyr'

import { createRoot } from 'react-dom/client'

import App from './App'
import * as serviceWorker from './config/serviceWorker'

const root = createRoot(document.getElementById('root')!)
root.render(<App />)

serviceWorker.unregister()
